import { FormProps, InputFileUpload } from "@components-common/forms";
import { useNotifications } from "@hooks";
import { application } from "../../../_runtime/bootstrap";
import { useFormikContext } from "formik";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col } from "taltech-styleguide";

/**
 * Component: UserGuideCreateFormContent
 *
 * This component renders the form content for uploading a file when creating a new user guide.
 * It provides a file input field and passes the selected file to the parent component via the `onFileChange` callback.
 *
 * @component
 * @param {object} props - The props for the component.
 * @param {function} props.onFileChange - A callback function that receives the selected file from the input.
 * @returns {React.FC} The UserGuideCreateFormContent component.
 */
export const UserGuideCreateFormContent: FC<any> = ({ onFileChange }) => (
  <Col xs="12" md="6" className="d-flex flex-column gap-3">
    <InputFileUpload
      type="FILE"
      handleFileFromOutside={true}
      setFile={onFileChange}
    />
  </Col>
);

/**
 * Component: UserGuideCreateForm
 *
 * This component handles the creation of a new user guide. It manages the form submission,
 * file upload, and interactions with the API to create a new user guide.
 *
 * @component
 * @param {FormProps<any>} props - The form props passed to the component.
 * @returns {React.FC} The UserGuideCreateForm component.
 */
export const UserGuideCreateForm: FC<FormProps<any>> = (props) => {
  const nav = useNavigate();
  const userNotifications = useNotifications();
  const formik = useFormikContext();
  const [file, setFile] = useState<File | null>(null);

  useEffect(() => {
    if (formik.isSubmitting) {
      var formData = new FormData();
      formData.append("Name", file!.name);
      formData.append("Type", "USER_GUIDE");
      formData.append("Description", "description");
      formData.append("Source", "System");
      if (file) {
        formData.append("File", file);
      } else {
        userNotifications.error({ title: "You need to upload a file." });
        return;
      }

      application
        .getHttpClient()
        .post("/mediasms/mediaitemresources/postWithStreaming", formData, {
          headers: {
            " Content-Type": "multipart/form-data",
          },
        })
        .then(() => nav(-1));
    }
  }, [formik.isSubmitting]);

  return <UserGuideCreateFormContent onFileChange={setFile} />;
};
